import $ from 'jquery';

export default class SystemStatus {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        // Copy To Clipboard functionality is only available
        // when site has SSL certificate, 
        // because Clipoard js API is only available then.
        if (location.protocol !== "https:") {
            return;
        }

        $(() => {
            $('.opd-system-status-copy-to-clipboard')
                .on('click', this.copyToClipboardButtonClick)
                .show();
        });
    }

    /**
     * Copy system status table to clipboard
     *
     * @param {Object} e
     */
    copyToClipboardButtonClick(e) {
        if (typeof navigator.clipboard === "undefined") {
            return window.OPDashboard.Helpers.notify("Clipboard API not available!", "error");
        }

        if (navigator.clipboard.writeText) {
            var textToCopy = [];
            var $systemStatusTable = $('.opd-system-status-table');

            (function ($) {
                $systemStatusTable
                    .find("tr")
                    .each(function(index, value) {
                        var $tr = $(value),
                            $label = $tr.find(".label"),
                            $message = $tr.find(".message");

                        textToCopy.push($label.text().trim() + ": " + $message.text().trim() + "\r\n");
                    });
            })(jQuery);

            navigator.clipboard
                .writeText(textToCopy.join(""))
                .then(function() {
                    window.OPDashboard.Helpers.notify("Copied to clipboard.", "success");
                })
                .catch(function(error) {
                    window.OPDashboard.Helpers.notify("Something went wrong while copying to clipboard!", "error");
                })
        }
    }

}